import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-right-direction-arrow';
export var ID = 'icon-right-direction-arrow';
/* eslint-disable max-len */

export var SVGRightDirectionArrow = function SVGRightDirectionArrow() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 12 22"
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    transform: "translate(-607.000000, -229.000000)",
    fill: "#BAB7B6"
  }, React.createElement("g", {
    transform: "translate(400.000000, 214.000000)"
  }, React.createElement("path", {
    d: "M218.137372,25.7086456 L218.222169,25.6238482 L207.598321,15 L207,15.5983211 L217.110325,25.7086456 L207,35.8189702 L207.598321,36.4172913 L218.222169,25.7934431 L218.137372,25.7086456 Z"
  })))));
};
/* eslint-disable max-len */

var RightDirectionArrow = function RightDirectionArrow(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGRightDirectionArrow
  });
};

RightDirectionArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default RightDirectionArrow;